import { render, staticRenderFns } from "./SimpleCrud.vue?vue&type=template&id=2796e113"
import script from "./SimpleCrud.vue?vue&type=script&lang=js"
export * from "./SimpleCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports